<template>
  <b-form-select
    v-model="valueForm"
    :options="options"
    :state="validateState('categoria_instituicao_id')"
  ></b-form-select>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import { mapActions, mapState } from "vuex";
import { map } from "lodash";


export default {
  mixins: [validationMixin],
  data: () => ({
    categorias: [],
  }),
  props: {
    value: {},
  },
  validations: {
    value: {
      categoria_instituicao_id: {
        required,
        minLength: minLength(1),
      },
    },
  },
  computed: {
    ...mapState("perfis", ["categorias_list"]),
    options() {
      return map(this.categorias_list, function (obj) {
        return {
          text: obj.nome,
          value: obj.id,
        };
      });
    },
    valueForm: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("perfis", ["ActionGetAllCategories"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
  },
  async created() {
    let response = await this.ActionGetAllCategories();
    this.categorias = response.data;
  },
};
</script>

<style></style>
